import * as fromSite from './site';
import * as fromSearch from './search';
import * as fromRoot from '../../../app.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface IrarState {
  site: fromSite.State;
  search: fromSearch.State;
}

export interface State extends fromRoot.State {
  irar: IrarState;
}

export const initialState: IrarState = {
  site: fromSite.initialState,
  search: fromSearch.initialState
};

/**
 * Because metareducers take a reducer function and return a new reducer,
 * we can use our compose helper to chain them together. Here we are
 * using combineReducers to make our top level reducer, and then
 * wrapping that in storeLogger. Remember that compose applies
 * the result from right to left.
 */
export const reducers = {
  site: fromSite.reducer,
  search: fromSearch.reducer
};

export const getIrarState = createFeatureSelector<IrarState>('irar');

export const getSiteState = createSelector(getIrarState, (state: IrarState) => state.site);
export const getSearchState = createSelector(getIrarState, (state: IrarState) => state.search);

export const getSiteLoading = createSelector(getSiteState, fromSite.loading);
export const getSites = createSelector(getSiteState, fromSite.sites);
export const getFarms = createSelector(getSiteState, fromSite.farms);
export const getSelectedSite = createSelector(getSiteState, fromSite.selectedSite);
export const getAuthors = createSelector(getSiteState, fromSite.authors);
export const getFarmGps = createSelector(getSiteState, fromSite.farmGps);
export const getAocGps = createSelector(getSiteState, fromSite.aocGps);

export const getSearchLoading = createSelector(getSearchState, fromSearch.loading);
export const getSearchCriteria = createSelector(getSearchState, fromSearch.criteria);
export const getSearchResultCount = createSelector(getSearchState, fromSearch.resultCount);
export const getSearchResults = createSelector(getSearchState, fromSearch.results);
export const getDocumentDetail = createSelector(getSearchState, fromSearch.detail);
export const getGlennDale = createSelector(getSearchState, fromSearch.glennDale);



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/reducers/index.ts